<template>
  <div>
    <div class="participant p-2 indigo white--text text-uppercase">
      {{ participant_name }}
    </div>
    <div
      id="message-list"
      class="d-flex flex-column mt-4"
    >
      <v-progress-linear
        v-if="is_loading"
        indeterminate
      />
      <agent-message
        v-for="message in messages"
        :key="message.id"
        :message="message"
        :me="me"
      />
      <v-textarea
        filled
        full-width
        auto-grow
        rows="1"
        hide-details
        clearable
        label="ข้อความ..."
        class="mt-auto message-textfield"
        style="background-color: #fefefe"
        multiple="true"
        @keyup.13="sendMessage"
        v-model="message"
      >
        <template #append>
          <v-icon
            class="px-4"
            @click="sendMessage"
          >
            mdi-send
          </v-icon>
        </template>
      </v-textarea>
    </div>
  </div>
</template>
<script>
import AgentMessage from './message.vue';

export default {
  name: 'AgentMessageList',
  components: {
    AgentMessage,
  },
  props: {
    messages: { type: Array, required: false, default: [] },
    participant: { type: Number, required: false, default: 0 },
    participant_name: { type: String, required: false, default: 'User' },
    me: { required: false, default: 0 },
  },
  data() {
    return {
      is_loading: false,
      message: '',
    };
  },
  methods: {
    async sendMessage(event) {
      this.is_loading = true;
      await axios
        .post(`/api/messages/agent/sendto/${this.participant}`, {
          message: this.message,
        })
        .then((response) => {
          if (response.status == 200) {
            const message = response.data;
            this.messages.push(message);
            event.target.value = '';
          }
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.is_loading = false;
          this.message = '';
        });
      this.$emit('messageUpdated');
    },
  },
};
</script>
<style scoped language="scss">
#message-list {
  position: relative;
  display: block;
  min-height: calc(100% - 60px);
}
.message-textfield {
  position: sticky;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 56px;
}
.participant {
  width: 100%;
  top: 0;
  position: sticky;
  text-align: center;
  z-index: 10000;
}
</style>
